import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

const CreateTeam = () => {

    const table1 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Teams Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Create Team</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="detail_top_pgg">
                        <Link to="/team-management"><i className="bx bx-arrow-back" /><span>Back</span></Link>
                    </div>
                    <div className="add_info_wrpr">
                        <form>
                            <div className="card personal_d">
                                <div className="card-body">
                                    <h2>Team Details</h2>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <input type="text" className="form-control" placeholder="Enter Team Name" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <select className="form-select" name="agegroup">
                                                <option selected value>Select Age Group</option>
                                                <option value="U-11">U-11</option>
                                                <option value="U-12">U-12</option>
                                                <option value="U-13">U-13</option>
                                                <option value="U-14">U-14</option>
                                                <option value="U-15">U-15</option>
                                                <option value="U-16">U-16</option>
                                                <option value="U-17">U-17</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input type="text" className="form-control" placeholder="Enter Country" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card personal_d">
                                <div className="card-body">
                                    <h2>Coach Details</h2>
                                    <Link to="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#invite_coach" className="d-flex align-items-center btn btn-primary font-18 ms-auto mb-3" style={{ width: 'fit-content', marginTop: '-60px' }}><i className="bx bx-plus ms-1" />
                                        <span>Invite Coach</span></Link>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <select className="form-select" name="coach">
                                                <option value="John Clark">John Clark</option>
                                                <option value="Robert Sean">Robert Sean</option>
                                                <option value="Richard Thomas">Richard Thomas</option>
                                                <option value="Michael Johnson">Michael Johnson</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <input type="email" className="form-control" placeholder="Enter Coach Email" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card personal_d">
                                <div className="card-body">
                                    <h2 className="m-0">Players List</h2>
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table1} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Position</th>
                                                    <th>Jersey</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Player One</td>
                                                    <td>Forward</td>
                                                    <td>#10</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/team-player-detail">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="Delete" className="bx bx-trash" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Player Two</td>
                                                    <td>Midfielder</td>
                                                    <td>#8</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/team-player-detail">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="Delete" className="bx bx-trash" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="card personal_d">
                                <div className="card-body">
                                    <h2>Add Player</h2>
                                    <h3 className="sub_plyers_heading">Player Info</h3>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">First Name</label>
                                            <input type="text" className="form-control" placeholder="First Name" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Last Name</label>
                                            <input type="text" className="form-control" placeholder="Last Name" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Date Of Birth</label>
                                            <input type="date" className="form-control" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Jersey Number</label>
                                            <input type="text" className="form-control" placeholder="Jersey Number" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Assign Team</label>
                                            <input type="text" className="form-control" placeholder="Assign Team" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Position</label>
                                            <input type="text" className="form-control" placeholder="Position" />
                                        </div>
                                    </div>
                                    <h3 className="mt-4 sub_plyers_heading">Add Parent/Guardian Info</h3>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Full Name</label>
                                            <input type="text" className="form-control" placeholder="Full Name" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Email Address</label>
                                            <input type="email" className="form-control" placeholder="Email Address" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Phone Number</label>
                                            <input type="text" className="form-control" placeholder="Phone Number" />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Relationship</label>
                                            <input type="email" className="form-control" placeholder="Relationship" />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Emergency Contact Number</label>
                                            <input type="text" className="form-control" placeholder="Emergency Contact Number" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary ms-auto d-block mb-3">Create Team</button>
                        </form>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="invite_coach" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header ">
                            <h5 className="modal-title">Confirmation Alert!</h5>
                            <button type="button" className="btn-close " data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    <div className="col-lg-12 mb-3">
                                        <label className="mb-3">Enter Coach Email</label>
                                        <input type="text" className="form-control" defaultValue="john_clark@gmail.com" />
                                    </div>
                                    <div className="col-lg-12">
                                        <label className="mb-3">Message</label>
                                        <textarea className="form-control" defaultValue={""} />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Send Invite</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="delete_modal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to delete this player?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateTeam